export default __webpack_public_path__ + "static/media/8.57e91b85.jpg";